
(function () {
  var storageKey = 'cartReservationExpiresAt';
  var intervalId = null;
  var clockEl = null; 

  function getEls() {
    return {
      wrap: document.querySelector('[data-cart-reservation-timer]'),
      text: document.querySelector('[data-cart-reservation-text]')
    };
  }

  function cartHasItems() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) { return cart.item_count > 0; })
      .catch(function () { return true; });
  }

  function getOrSetExpiry(durationMs) {
    var stored = localStorage.getItem(storageKey);
    var now = Date.now();
    if (stored && parseInt(stored, 10) > now) return parseInt(stored, 10);
    var expiresAt = now + durationMs;
    localStorage.setItem(storageKey, String(expiresAt));
    return expiresAt;
  }

  function formatTime(ms) {
    var totalSeconds = Math.max(0, Math.floor(ms / 1000));
    var m = Math.floor(totalSeconds / 60);
    var s = totalSeconds % 60;
    return (m < 10 ? '0' + m : m) + ':' + (s < 10 ? '0' + s : s);
  }

  function buildReservedText(wrap, textEl, initialLabel) {
    var template = wrap.getAttribute('data-reserved-text') || 'Your items are reserved for the next {{ time }}';
    var parts = template.split('{{ time }}');

    textEl.textContent = '';
    clockEl = document.createElement('strong');
    clockEl.className = 'cart-reservation-timer__clock';
    clockEl.setAttribute('data-cart-reservation-clock', '');
    clockEl.textContent = initialLabel;

    if (parts[0]) textEl.appendChild(document.createTextNode(parts[0]));
    textEl.appendChild(clockEl);
    if (parts[1]) textEl.appendChild(document.createTextNode(parts[1]));
  }

  function expireReservation() {
    var els = getEls();
    if (intervalId) clearInterval(intervalId);
    localStorage.removeItem(storageKey);

    if (els.wrap && els.text) {
      els.wrap.classList.add('is-expired');
      els.text.textContent = els.wrap.getAttribute('data-expired-text') || 'Your reservation expired.';
    }

    fetch('/cart/clear.js', { method: 'POST', headers: { 'Accept': 'application/json' } })
      .catch(function () {})
      .finally(function () {
        setTimeout(function () { window.location.reload(); }, 1200);
      });
  }

  function tick(expiresAt) {
    var els = getEls();
    if (!els.wrap || !clockEl || !document.body.contains(clockEl)) {
      clearInterval(intervalId);
      intervalId = null;
      return;
    }

    var remaining = expiresAt - Date.now();

    if (remaining <= 0) {
      expireReservation();
      return;
    }

    clockEl.textContent = formatTime(remaining);
    els.wrap.classList.toggle('is-ending', remaining <= 60 * 1000);
  }

  function initCartReservationTimer() {
    var els = getEls();
    if (!els.wrap || !els.text) return;
    if (intervalId) clearInterval(intervalId);

    var minutes = parseInt(els.wrap.getAttribute('data-minutes'), 10) || 10;
    var durationMs = minutes * 60 * 1000;

    cartHasItems().then(function (hasItems) {
      var els2 = getEls();
      if (!els2.wrap) return;

      if (!hasItems) {
        els2.wrap.style.display = 'none';
        localStorage.removeItem(storageKey);
        return;
      }

      els2.wrap.style.display = '';
      els2.wrap.classList.remove('is-expired');

      var expiresAt = getOrSetExpiry(durationMs);
      buildReservedText(els2.wrap, els2.text, formatTime(expiresAt - Date.now()));
      tick(expiresAt);
      intervalId = setInterval(function () { tick(expiresAt); }, 1000);
    });
  }


  var observer = new MutationObserver(function () {
    var wrap = document.querySelector('[data-cart-reservation-timer]');
    if (wrap && !wrap.dataset.reservationBound) {
      wrap.dataset.reservationBound = 'true';
      initCartReservationTimer();
    }
  });

  function start() {
    observer.observe(document.body, { childList: true, subtree: true });
    initCartReservationTimer(); // in case the drawer is already in the DOM
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();